import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=1c6207fb"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports